export default "__VITE_ASSET__DLIK52NG__"